<script>
    export let imgOnly = false;
    export let name;
    export let multi = true;
    export let uploaded = [];
    export let selected = {
      upload: [],
      delete: []
    };
    export let selectedData = [];
    let input;
    let fileSizeExceed = false;
    function clicked() {
        if (multi === false && (uploaded.length === 1 || selected.upload.length === 1)) return;
        input.click();
    }

    function inputChanged(e) {
        Object.values(e.target.files).forEach(file => {
            const reader = new FileReader();
            reader.onload = (read) => {
                if (read.total > 10000000) {
                    fileSizeExceed = true
                }
                else {
                    fileSizeExceed = false
                    selected.upload = [...selected.upload, file];
                    selectedData = [...selectedData, { url: read.target.result, type: file.type }]
                }
            };
            reader.readAsDataURL(file);
        });
    }

    function remove(index) {
        selected.upload = selected.upload.filter((_, i) => i !== index);
        selectedData = selectedData.filter((_, i) => i !== index);
    }

    function removeUploaded(file) {
        uploaded = uploaded.filter((uploaded) => uploaded !== file);
        selected.delete = [...selected.delete, file];
    }

    function img(file) {
        if (!file) return;
        const ext = file.split(".")[1];


        if (ext === "jpeg" || ext === "png") {
          return `https://storage.googleapis.com/estatemanager/${file}`;
        }
        if (ext === "pdf") {
            return "/img/pdf.png";
        }
        return "/img/ic_file.png";
    }

    function imgFromData(data) {
        if (data.type === "image/jpeg" || data.type === "image/png") {
            return data.url;
        }
        if (data.type === "application/pdf") {
            return "/img/pdf.png";
        }
        return "/img/ic_file.png";
    }
</script>

<div class="px-2">
    {#if uploaded && uploaded.length > 0 || selected && selected.upload && selected.upload.length > 0}
        <div class="preview-container">
            {#each uploaded as file}
                <div class="img">
                    <img src="{img(file)}" class="preview-img" alt="image"/>
                    <div class="delete">
                        <svg on:click={() => removeUploaded(file)} version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                             viewBox="0 0 19.342 19.342" xml:space="preserve">
                            <g>
                                <path d="M2.833,4.491c0,0,0.513,0.491,0.513,0.776v12.568c0,0.832,0.736,1.507,1.645,1.507h9.362
                                    c0.908,0,1.644-0.675,1.644-1.507V5.268c0-0.286,0.515-0.776,0.515-0.776V2.969H2.833V4.491z M12.36,6.23h1.223v9.705H12.36V6.23z
                                     M9.086,6.23h1.22v9.705h-1.22V6.23z M6.137,6.23h1.221v9.705H6.137V6.23z"/>
                                <path d="M17.108,1.711h-3.791C13.128,0.74,12.201,0,11.087,0H8.257C7.143,0,6.216,0.74,6.027,1.711H2.235
                                    v0.93h14.873V1.711z M7.297,1.711c0.156-0.344,0.528-0.586,0.96-0.586h2.829c0.433,0,0.804,0.243,0.961,0.586H7.297z"/>
                            </g>
                        </svg>
                    </div>
                </div>
            {/each}
            {#each selectedData as data, i}
                <div class="img">
                    <img src="{imgFromData(data)}" class="preview-img" alt="image"/>
                    <div class="delete">
                        <svg on:click={() => remove(i)} version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                             viewBox="0 0 19.342 19.342" xml:space="preserve">
                            <g>
                                <path d="M2.833,4.491c0,0,0.513,0.491,0.513,0.776v12.568c0,0.832,0.736,1.507,1.645,1.507h9.362
                                    c0.908,0,1.644-0.675,1.644-1.507V5.268c0-0.286,0.515-0.776,0.515-0.776V2.969H2.833V4.491z M12.36,6.23h1.223v9.705H12.36V6.23z
                                     M9.086,6.23h1.22v9.705h-1.22V6.23z M6.137,6.23h1.221v9.705H6.137V6.23z"/>
                                <path d="M17.108,1.711h-3.791C13.128,0.74,12.201,0,11.087,0H8.257C7.143,0,6.216,0.74,6.027,1.711H2.235
                                    v0.93h14.873V1.711z M7.297,1.711c0.156-0.344,0.528-0.586,0.96-0.586h2.829c0.433,0,0.804,0.243,0.961,0.586H7.297z"/>
                            </g>
                        </svg>
                    </div>
                </div>
            {/each}
        </div>
    {/if}
    <div class="upload-file-wrapper">
        <input name={name} type="file" multiple={multi} bind:this={input} on:change="{inputChanged}"/>
    </div>
    <span class="btn image-picker-btn hover:bg-blue-700 bg-blue-600" class:btn-disabled={multi === false && (uploaded.length === 1 || selected.upload.length === 1)} on:click="{clicked}">
        {imgOnly === true ? "Kép hozzáadása" : "Fájl hozzáadása"}
    </span>
        {#if fileSizeExceed === true}
            <span class="text-red-500 p-2">
                A feltöltött kép túl nagy. Maximálisan feltölthető méret: 10mb.
            </span>
        {/if}
</div>

<style>
    .delete {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: none;
        align-items: center;
        justify-content: center;
        background: #504e508C;
    }
    .btn-disabled {
        background-color: #b8b8b8 !important;
        color: grey !important;
    }
    .img:hover .delete {
        display: flex;
    }
    .delete svg {
        height: 3rem;
        color: white;
        cursor: pointer;
    }
    .delete svg:hover {
        fill: white;
    }
    .img {
        position: relative;
    }

    .preview-container {
        min-height: 12rem;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr;

        border: 2px dashed grey;
        /*margin-bottom: 1rem;*/
    }

    .preview-img {
        height: 15rem;
        object-fit: cover;
        width: 100%;
        box-sizing: border-box;
        padding: .3em;
        position: relative;
    }

    /*.img:hover::after {*/
    /*    content: '';*/
    /*    cursor: pointer;*/
    /*    !*width: 50px;*!*/
    /*    !*height: 50px;*!*/
    /*    position: absolute;*/
    /*    right: 0;*/
    /*    top: 0;*/
    /*    left: 0;*/
    /*    bottom: 0;*/
    /*    background: #504e508C;*/
    /*}*/

    .image-picker-btn {
        display: inline-block;
        padding: 1rem;
        cursor: pointer;
    }

    .upload-file-wrapper {
        height: 0;
        overflow: hidden;
        margin-bottom: .5rem;
    }
</style>